import { createUseStyles } from 'react-jss'
import { DARK_GRAY_80, WHITE } from '@omnilert/components'

export default createUseStyles({
  fadeIn: { animation: '$fadeIn 0.3s' },
  '@keyframes fadeIn': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  closeIcon: {
    '--icon__primary__stroke__color': WHITE
  },
  cornerButton: {
    position: 'static !important',
    margin: '5px 0'
  },
  modalContainer: {
    alignItems: 'center',
    backgroundColor: DARK_GRAY_80,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 101
  },
  modalContent: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 'auto 0px',
    padding: '0px 25px 50px 25px',
    overflow: 'hidden'
  }
})
